import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from "../../../../../Components/UI/Paper";
import UserDetails from "./components/UserDetails";
import { useParams } from "react-router-dom";
import { getUser, getUserTypes } from "API/swesum";

export function UserCard() {
  const [user, setUser] = useState(null);
  const [userTypes, setUserTypes] = useState(null);

  const { userID } = useParams();
  useEffect(() => {
    const asyncFetchUser = async () => {
      const tmpUser = await getUser(userID);
      const tmpUserTypes = await getUserTypes();
      setUserTypes(tmpUserTypes);
      setUser(tmpUser);
    };
    asyncFetchUser();
  }, [userID]);

  if (!user) {
    return null;
  }
  return (
    <>
      <Box component="main" sx={{ flexGrow: 1, overflow: "auto" }}>
        <Box sx={{ flexGrow: 1, p: 3 }}>
          <Typography variant="h5" gutterBottom>
            {"Användare - "}
            {user.Username}
          </Typography>
          <Grid
            container
            rowSpacing={3}
            columnSpacing={{ xs: 1, sm: 2, md: 2 }}
          >
            <Grid item xs={12} md={12}>
              <Paper>
                <Typography sx={{ marginBottom: "2rem" }} variant="h5">
                  Användarkort
                </Typography>
                <UserDetails user={user} userTypes={userTypes} />
              </Paper>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
}
